import { addStyles } from 'ethcss'
import { radiusSizes } from 'blocks.app/config'
import { grid, IStyles, item, mediaCSS } from '../../theme'

const uploadLogTasksStyles: IStyles = {
    sidebarHeader: {
        padding: 20,
        fontSize: 16,
        textAlign: 'center',
    },
    itemTitle: {
        fontSize: 14,
        textAlign: 'center',
    },
    buttons: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        textAlign: 'center',
    },
}

addStyles(uploadLogTasksStyles)
export default uploadLogTasksStyles
